<template>
  <div class="grid grid-cols-1 md:grid-cols-12 gap-8">
    <div :key="articles[0].id" class="col-span-1 md:col-span-12">
      <news-top-article
        :article="articles[0]"
        class="news__article news__article--top"
        :full-width-mobile="topArticleHasFullWidthMobile"
      />
    </div>
    <div
      v-for="article in articles.slice(1)"
      :key="article.id"
      class="col-span-1 md:col-span-4"
    >
      <news-article :article="article" class="news__article" />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { StrapiArticle } from '~/apollo/types/types';

const props = withDefaults(
  defineProps<{
    articles: Array<StrapiArticle>;
    topArticleHasFullWidthMobile: boolean;
  }>(),
  {
    articles: () => [],
    topArticleHasFullWidthMobile: false,
  },
);
</script>

<style scoped>
.news__article {
  height: 280px;
}

@media (min-width: 768px) and (max-width: 1024px) {
  .news__article {
    height: 280px;
  }
}

.news__article--top {
  min-height: 28rem;
}

@media (min-width: 768px) {
  .news__article--top {
    min-height: 22rem;
  }
}
</style>
